/**
 * Valid puzzle type filters for leaderboard
 */
const PUZZLE_TYPE_FILTERS = ["all", "positional", "tactic"] as const;

export type PuzzleTypeFilter = (typeof PUZZLE_TYPE_FILTERS)[number];

export function isPuzzleTypeFilter(value: string): value is PuzzleTypeFilter {
    return PUZZLE_TYPE_FILTERS.some((filter) => filter === value);
}

/** Rush leaderboard periods. */
export const RUSH_PERIODS = ["daily", "weekly", "monthly", "allTimes"] as const;

export type RushPeriod = (typeof RUSH_PERIODS)[number];

export function isRushPeriod(value: string): value is RushPeriod {
    return RUSH_PERIODS.some((period) => period === value);
}

/** Which board to rank, with its filter. */
export type LeaderboardBoard =
    | { kind: "puzzles"; type: PuzzleTypeFilter }
    | { kind: "rush"; period: RushPeriod }
    | { kind: "battleWins" };

/** The API route serving a board: pages at `?page=N`, the viewer's row at `/me`. */
export function leaderboardEndpoint(board: LeaderboardBoard): string {
    switch (board.kind) {
        case "puzzles":
            return `/api/puzzle/get-leaderboard/${board.type}`;
        case "rush":
            return `/api/puzzle/get-rush-leaderboard/${board.period}`;
        case "battleWins":
            return "/api/battle/leaderboard/wins";
    }
}

/** One ranked user, whatever the board ranks them by. */
export type LeaderboardRow = {
    userId: number;
    rank: number;
    name: string;
    score: number;
};

/** A page of a leaderboard API response. */
export type LeaderboardPage = {
    rows: LeaderboardRow[];
    pageCount: number;
};

export const LEADERBOARD_PAGE_SIZE = 10;
